import { makeAutoObservable, runInAction } from "mobx";
import StudioAuthController, { UserMe } from "../controllers/StudioAuthController";
import { UserPermissionModel } from "../controllers/StudioAdminController";

export default class StudioUserStore {
  private _studioAuthController = new StudioAuthController(
    process.env.REACT_APP_STUDIO_API_HOST_URL ?? "",
    process.env.REACT_APP_STUDIO_API_KEY_ADMIN ?? ""
  );

  isLoggedIn: boolean = false;
  me: UserMe | null = null;

  constructor() {
    makeAutoObservable(this);
    this.initAsync();
  }

  // 앱 시작 시 쿠키로 로그인 상태 복원
  private async initAsync() {
    try {
      const me = await this._studioAuthController.getMeAsync();
      runInAction(() => {
        this.me = me;
        this.isLoggedIn = true;
      });
    } catch {
    }
  }


  public async logInAsync(email: string, password: string) {
    await this._studioAuthController.loginWithEmailAsync(email, password);
    const me = await this._studioAuthController.getMeAsync();
    runInAction(() => {
      this.me = me;
      this.isLoggedIn = true;
    });
  }

  public async logOutAsync() { 
    await this._studioAuthController.logoutAsync();
    this.isLoggedIn = false;
    this.me = null;
  }

  private rolePermissions: Record<string, string[]> = {
    admin: ["*"], // 모든 권한
    manager: ["*"], // 모든 권한
    publisher: [
      "menu:content:view", "menu:publish:view", "menu:sales:view",
      "block:view", "block:create", "block:edit", "block:publish",
      "category:view", "category:create", "category:edit", "category:publish",
      "license:view", "license:create", "license:edit", "license:publish",
      "categoryPackage:view", "categoryPackage:create", "categoryPackage:edit", "categoryPackage:publish",
      "publish:view"],
    default: [
      "menu:sales:view"],
  };

  public hasPermission(permission: string): boolean {
    const role = this.me?.role;
    if (!role) return false;

    const permissions = this.rolePermissions[role] || [];
    return permissions.includes("*") || permissions.includes(permission);
  }

  public hasWritePermission(permissions: UserPermissionModel[]) {
    if (this.me?.role === "admin" || this.me?.role === "manager")
      return true;

    return permissions && permissions.some(i => i.userId === this.me?.userId && i.permissions.includes("write"));
  }
}